import React from "react";
import Slider from "react-slick";



const NextArrow = ({ onClick }) => (
  <div className="slick-custom-arrow slick-custom-next" onClick={onClick}>
    <i className="fa fa-chevron-right"></i>
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slick-custom-arrow slick-custom-prev" onClick={onClick}>
    <i className="fa fa-chevron-left"></i>
  </div>
);

const Sliderr = () => {


// const slides = [
//   {
//     car: "/images/sliders/car.png",
//     carName: "Maruti Suzuki Dzire",
//     title: "Reliable Corporate Sedan Rentals in Pune",
//     titlee: "Professional | Punctual | Reliable",
//     subtitle: "Corporate Car Services",
//     desc: "Comfortable and cost-effective sedan rentals ideal for daily corporate travel and airport transfers.",
//   },
//   {
//     car: "/images/sliders/2.png",
//     carName: "Maruti Suzuki Ertiga",
//     title: "Efficient Employee Transportation Solutions",
//     titlee: "Safe | Reliable | Comfortable",
//     subtitle: "Employee Transport Services",
//     desc: "Perfect for staff transportation with spacious seating, comfort, and dependable performance.",
//   },
//   {
//     car: "/images/sliders/3.png",
//     carName: "Toyota Innova Crysta",
//     title: "Trusted Partner for Corporate Mobility",
//     titlee: "Comfortable | Reliable | On-Time",
//     subtitle: "Pune Car Rental Services",
//     desc: "India’s most trusted MPV for corporate travel, meetings, and long-distance business journeys.",
//   },
//   {
//     car: "/images/sliders/4.png",
//     carName: "Toyota Fortuner",
//     title: "Pan India Corporate Transport Services",
//     titlee: "Cost-Effective | Timely | Dependable",
//     subtitle: "Nationwide Corporate Car Rentals",
//     desc: "Executive SUV ideal for senior management travel and nationwide corporate operations.",
//   },
//   {
//     car: "/images/sliders/5.png",
//     carName: "Toyota Camry",
//     title: "Premium Executive Sedan for Corporate Travel",
//     titlee: "Trusted | Timely | Professional",
//     subtitle: "Executive Sedan Services",
//     desc: "Luxury executive sedan offering refined comfort for business leaders and VIP corporate guests.",
//   },
//   {
//     car: "/images/sliders/6.png",
//     carName: "BMW 5 Series",
//     title: "Luxury Cars for Business Travel",
//     titlee: "Safe | Secure | Trusted",
//     subtitle: "Luxury Car Rentals Pune",
//     desc: "High-end luxury sedan designed for elite business travel and executive-level comfort. ",
//   },
//   {
//     car: "/images/sliders/7.png",
//     carName: "Mercedes-Benz C-Class",
//     title: "Premium Chauffeur-Driven Cars for Corporates",
//     titlee: "Quality | Safety | Reliability",
//     subtitle: "Luxury Chauffeur Services",
//     desc: "Top-tier chauffeur-driven luxury cars for corporate executives and VIP transportation.",
//   }
// ];

const slides = [
  {
    car: "/images/sliders/car.png",
    carName: "Maruti Suzuki Dzire",
    title: "Reliable Corporate Car Rental Services",
    titlee: "Professional | Reliable | On-Time",
    subtitle: "Corporate Car Services",
    desc: "Comfortable and cost-effective Car rentals for daily corporate travel and airport transfers.",
  },
  {
    car: "/images/sliders/2.png",
    carName: "Maruti Suzuki Ertiga",
    title: "Efficient Employee Transportation Services",
    titlee: "Safe | Reliable | Comfortable",
    subtitle: "Employee Transport Services",
    // desc: "Spacious and comfortable vehicle ideal for regular staff and office commuting.",
    desc: "Spacious and comfortable vehicle ideal for regular staff and office commuting for company employees.",
  },
  { 
    car: "/images/sliders/3.png",
    carName: "Toyota Innova Crysta",
    title: "Trusted Corporate Travel & Mobility Partner",
    titlee: "Comfortable | Reliable | Timely",
    subtitle: "Pune Car Rental Services",
    // desc: "Popular MPV choice for corporate meetings, airport travel, and long-distance trips.",
    desc: "Popular MPV choice for corporate meetings, airport travel, and long-distance trips with premium comfort.",
  },
  {
    car: "/images/sliders/4.png",
    carName: "Toyota Fortuner",
    title: "Pan India Corporate Transport Solutions Professional",
    titlee: "Efficient | Timely | Dependable",
    subtitle: "Nationwide Corporate Rentals",
    desc: "Executive SUV designed for senior management travel and nationwide corporate operations.",
  },
  {
    car: "/images/sliders/5.png",
    carName: "Toyota Camry",
    title: "Premium Executive Car  for Corporates",
    titlee: "Trusted | Professional | Timely",
    subtitle: "Executive Car  Services",
    // desc: "Luxury executive sedan delivering refined comfort for business leaders and VIP guests.for business leaders and VIP guests",
    desc: "Luxury executive Car delivering refined comfort for business leaders and VIP guests with premium interiors and performance.",
  },
  {
    car: "/images/sliders/6.png",
    carName: "BMW 5 Series",
    title: "Luxury Business Travel Car Rentals Executive",
    titlee: "Safe | Secure | Trusted",
    subtitle: "Luxury Car Rentals Pune",
    // desc: "High-end luxury sedan offering elite comfort for executive-level corporate travel.for executive-level corporate travel",
       desc: "High-end luxury Car offering elite comfort for executive-level corporate travel with premium features and superior ride quality.",
  },
  {
    car: "/images/sliders/7.png",
    carName: "Mercedes-Benz C-Class",
    title: "Premium Chauffeur-Driven Corporate Cars",
    titlee: "Quality | Safety | Reliability",
    subtitle: "Luxury Chauffeur Services",
    // desc: "Chauffeur-driven luxury sedan ideal for corporate executives and VIP transportation.",
    desc: "Chauffeur-driven luxury Car ideal for corporate executives and VIP transportation tailored to professionals.",
  }
];

  const settings = {
    dots: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 7000,
    speed: 1800,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
  };

  return (
    <section className="slider style_one slider-bg">
      <Slider {...settings} className="theme_carousel">
        {slides.map((slide, index) => (
          <div className="slide-item-content" key={index}>
            <div className="slide-item content_left">

           

              <div className="container">
                <div className="row align-items-center">

                  {/* LEFT CONTENT */}
                   <div className="col-lg-6 col-md-6 col-sm-12 vh-50">
                    <div className="slider_content">
                    {/*  <h6 className="animate_up d-inline-block ">{slide.title}</h6><br/>
                      <h5 className="animate_up d-inline-block text-white">{slide.titlee}</h5>

                      <h1
                        className="animate_left"
                        dangerouslySetInnerHTML={{
                          __html: slide.title.replace("Cars", "<br>Cars"),
                        }}
                      ></h1> */}
                      <h6 className="slider-subtitle animate_up text-white">
  {slide.title}
</h6>

<h5 className="slider-tagline animate_up ">
  {slide.titlee}
</h5>

<h1 className="slider-title animate_left">
  {slide.title}
</h1>




                      <p className="description animate_right">{slide.desc}</p>

                      <div className="button_all animate_down">
                        <a
                          href="/book"
                          target="_blank"
                          rel="nofollow"
                          className="btn-style-two animated"
                        >
                          Book Now
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* RIGHT CAR IMAGE */}
                  {/* <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="slider-image animate_left">
                      <img src={slide.car} alt="slider car" />
                    </div>
                  </div> */}
                  {/* RIGHT CAR IMAGE */}
<div className="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center ">
{/* <div className="col-lg-6 col-md-6 col-sm-12 order-lg-2 order-1 "> */}
  <div className="slider-image animate_left mobile-car-fix ">
    <img src={slide.car} alt={slide.carName} />
  </div>
</div>


                </div>
              </div>

            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Sliderr;
